// import { Grid, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Autocomplete, TextField, TableFooter } from '@mui/material';
// import React, { Fragment, memo, useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { useStyle } from '../style';
// import axios from 'axios';
// import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
// import _ from 'lodash';
// import { Helmet } from 'react-helmet-async';
// import dayjs from 'dayjs';
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import moment from 'moment';
// import * as XLSX from 'xlsx';
// import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
// import { CSVLink } from 'react-csv';
// import { logDOM } from '@testing-library/react';

// const SalesTransferReport = () => {

//   const dispatch = useDispatch();
//   const classes = useStyle();
//   const [data, setData] = useState([]);
//   const outletName = localStorage.getItem('outlet_name');
//   const outletId = localStorage.getItem('outlet_id');
//   const fixedOutlet = { id: outletId, fullname: outletName };
//   const [supplier, setSupplier] = useState([]);
//   const [salesMargin, setSalesMargin] = useState("0.00");
//   const [outletType, setOutletType] = useState("");
//   const roleId = localStorage.getItem("role_id");
//   const [cust, setCust] = useState(null);
// console.log(outletType,"outletType");

//   const [dateLimit, setDateLimit] = useState({
//     fromDate: moment().subtract(1, 'months').format(),
//     toDate: moment().format()
//   });

//   const handleChange = (e, name) => {
//     setDateLimit(prev => ({ ...prev, [name]: dayjs(e).format() }));
//   };

//   const getSupplierData = () => {
//     axios.get("/v1/outlet/list/1")
//       .then((res) => {
//         setSupplier(res.data);
//         const selectedOutlet = res.data.find(val => val.id == outletId);
//         if (selectedOutlet) {
//           setCust(selectedOutlet);
//           setOutletType(selectedOutlet.outlet_type_name || "");
//           setSalesMargin(selectedOutlet.sales_margin || "");
//         }
//       })
//       .catch(err => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   };

//   const getSalesTransferReport = () => {
//     const postData = {
//       from_date: moment(dateLimit.fromDate).format('YYYY-MM-DD'),
//       to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
//       customer: cust ? cust.id : fixedOutlet.id
//     };

//     axios.post(`/v1/reports/sales/transfer`, postData)
//       .then(res => {
//         setData(res.data || []);
//       })
//       .catch(err => {
//         setData([]);
//         dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
//       });
//   };

//   useEffect(() => {
//     getSupplierData();
//   }, []);

//   useEffect(() => {
//     getSalesTransferReport();
//   }, [dateLimit, cust, salesMargin, outletType]);

//   const sortedData = _.sortBy(data, [item => moment(item.docdate).toDate()]);

//   // Totals Calculation
//   const totals = sortedData.reduce((acc, val) => {
//     // const baseWithMargin = outletType === "OTHERS"
//     //   ? parseFloat(val.amount) + (parseFloat(val.amount) * parseFloat(salesMargin) / 100)
//     //   : parseFloat(val.amount);
//   const amount = parseFloat(val.amount) || 0;
//   const gstPer = parseFloat(val.gst_per) || 0;
//   const margin = parseFloat(salesMargin) || 0;
// const isAfterJulyFirst2025 = moment(val.docdate).isSameOrAfter("2025-07-01");

//   const baseWithMargin = outletType === "OTHERS" && isAfterJulyFirst2025
//     ? amount + (amount * margin / 100)
//     : amount;

//   // const baseWithMargin = outletType === "OTHERS"
//   //   ? amount + (amount * margin / 100)
//   //   : amount;
//     // const gstAmount = baseWithMargin * (parseFloat(val.gst_per) / 100);
//  const gstAmount = baseWithMargin * (gstPer / 100);
//     acc.amount += baseWithMargin ;
//     acc.gst_amt += gstAmount ;
//     acc.total += baseWithMargin + gstAmount ;
//     acc.cgst += gstAmount.toFixed(2) / 2 ;
//     acc.sgst += gstAmount.toFixed(2) / 2 ;
// console.log(gstAmount.toFixed(2),"gstAmount12222");


//     return acc;
//   }, { amount: 0, gst_amt: 0, total: 0, cgst: 0, sgst: 0 });

//   const totalWithoutTax = totals.amount ;
//   const totalCGST = totals.cgst ;
//   const totalSGST = totals.sgst ;
//   const totalTax = totals.cgst + totals.sgst ;
//   const totalMRP = totals.total ;
// console.log(totalCGST,totalTax,"totalCGST");

//   // CSV Data Preparation
//   const csvData = sortedData.map(item => {
//       const amount = parseFloat(item.amount) || 0;
//   const gstPer = parseFloat(item.gst_per) || 0;
//   const margin = parseFloat(salesMargin) || 0;

//   // const baseWithMargin = outletType === "OTHERS"
//   //   ? amount + (amount * margin / 100)
//   //   : amount;

//       const isAfterJulyFirst2025 = moment(item.docdate).isSameOrAfter("2025-07-01");

//   const baseWithMargin = outletType === "OTHERS" && isAfterJulyFirst2025
//     ? amount + (amount * margin / 100)
//     : amount;
//     // const gstAmount = baseWithMargin * (parseFloat(val.gst_per) / 100);
//  const gstAmount = baseWithMargin * (gstPer / 100);
//     // const baseWithMargin = outletType === "OTHERS"
//     //   ? parseFloat(item.amount) + (parseFloat(item.amount) * parseFloat(salesMargin) / 100)
//     //   : parseFloat(item.amount);

//     // const gstAmount = baseWithMargin * (parseFloat(item.gst_per) / 100);
//     const totalAmount = baseWithMargin + gstAmount;

//     return {
//       Date: moment(item.docdate).format('DD-MM-YYYY'),
//       'Bill No': item.docno,
//       'HSN': item.hsn,
//       'Tax PER %': parseFloat(item.gst_per).toFixed(0),
//       'Qty': Math.round(item.qty),
//       'Base Value': baseWithMargin.toFixed(2),
//       'CGST': (gstAmount.toFixed(2) / 2).toFixed(2),
//       'SGST': (gstAmount.toFixed(2) / 2).toFixed(2),
//       'Total Tax': gstAmount.toFixed(2),
//       'Amount': totalAmount.toFixed(0),
//     };
//   });

//   const csvDataWithTotal = [
//     ...csvData,
//     {},
//     {
//       Date: 'Total',
//       'Bill No': '',
//       'HSN': '',
//       'Tax PER %': '',
//       'Qty': '',
//       'Base Value': totalWithoutTax.toFixed(2),
//       'CGST': totalCGST.toFixed(2),
//       'SGST': totalSGST.toFixed(2),
//       'Total Tax': totalTax.toFixed(2),
//       'Amount': totalMRP.toFixed(0),
//     }
//   ];

//   // Optional Excel Export
//   const exportToExcel = () => {
//     const worksheet = XLSX.utils.json_to_sheet(csvDataWithTotal);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "SalesTransferReport");
//     XLSX.writeFile(workbook, "Sales_Transfer_Report.xlsx");
//   };

//   return (
//     <Fragment>
//       <Helmet><title>Sales Transfer Report</title></Helmet>
//       <Typography variant='h6'>Sales Transfer Report</Typography>

//       <Grid container spacing={2} className="p-2 pt-2">
//         <Grid item md={3}>
//           <Autocomplete
//             size="small"
//             value={cust}
//             options={supplier}
//             onChange={(e, value) => {
//               setCust(value);
//               setOutletType(value?.outlet_type_name || "");
//               setSalesMargin(value?.sales_margin || "");
//             }}
//             getOptionLabel={option => option.fullname}
//             disabled={roleId != 1 && roleId != 2}
//             renderInput={(params) => <TextField {...params} label="Select Outlet" />}
//           />
//         </Grid>

//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               value={dayjs(dateLimit.fromDate)}
//               format='DD-MM-YYYY'
//               slotProps={{ textField: { size: "small", label: 'From', style: { width: '100%' } } }}
//             />
//           </LocalizationProvider>
//         </Grid>

//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "toDate")}
//               value={dayjs(dateLimit.toDate)}
//               format='DD-MM-YYYY'
//               slotProps={{ textField: { size: "small", label: 'To', style: { width: '100%' } } }}
//             />
//           </LocalizationProvider>
//         </Grid>
//       </Grid>

//       <Grid className='text-end my-2'>
//         <CSVLink data={csvDataWithTotal} filename={"Sales_Transfer_Report.csv"} className="btn btn-outline-primary">
//           <Button variant="outlined">Export to CSV <SimCardDownloadOutlinedIcon /></Button>
//         </CSVLink>

      
//       </Grid>

//       <Grid className='flex'>
//         <TableContainer className={classes.tblRoot} sx={{ height: "500px !important", overflow: "auto" }}>
//           <Table>
//             <TableHead className={classes.tblHeader} sx={{ position: "sticky", top: 0 }}>
//               <TableRow className={classes.tablrow}>
//                 <TableCell colSpan={10} align='center' sx={{ borderLeft: `1px solid #ccc` }}>Sales Transfer Report</TableCell>
//               </TableRow>
//               <TableRow className={classes.tablrow}>
//                 <TableCell sx={{ borderLeft: `1px solid #ccc` }}>Date</TableCell>
//                 <TableCell>Bill No</TableCell>
//                 <TableCell>HSN</TableCell>
//                 <TableCell>Tax PER %</TableCell>
//                 <TableCell>Qty</TableCell>
//                 <TableCell>Base Value</TableCell>
//                 <TableCell>CGST</TableCell>
//                 <TableCell>SGST</TableCell>
//                 <TableCell>Total Tax</TableCell>
//                 <TableCell>Amount</TableCell>
//               </TableRow>
//             </TableHead>

//             <TableBody>
//               {/* {sortedData.map((val, idx) => {
//                 const baseWithMargin = outletType === "OTHERS"
//                   ? parseFloat(val.amount) + (parseFloat(val.amount) * parseFloat(salesMargin) / 100)
//                   : parseFloat(val.amount);

//                 const gstAmount = baseWithMargin * (parseFloat(val.gst_per) / 100);
//                 const totalAmount = baseWithMargin + gstAmount;

//                 return (
//                   <TableRow key={idx} className={classes.tablrow1}>
//                     <TableCell sx={{ borderLeft: `1px solid #ccc` }}>{moment(val.docdate).format('DD-MM-YYYY')}</TableCell>
//                     <TableCell>{val.docno}</TableCell>
//                     <TableCell>{val.hsn}</TableCell>
//                     <TableCell>{parseFloat(val.gst_per).toFixed(2)}</TableCell>
//                     <TableCell>{Math.round(val.qty)}</TableCell>
//                     <TableCell>{baseWithMargin.toFixed(2)}</TableCell>
//                     <TableCell>{(gstAmount / 2).toFixed(2)}</TableCell>
//                     <TableCell>{(gstAmount / 2).toFixed(2)}</TableCell>
//                     <TableCell>{gstAmount.toFixed(2)}</TableCell>
//                     <TableCell sx={{ textAlign: "right", fontWeight: 600 }}>{totalAmount.toFixed(2)}</TableCell>
//                   </TableRow>
//                 );
//               })} */}
//               {sortedData.map((val, idx) => {
//   const amount = parseFloat(val.amount) || 0;
//   const gstPer = parseFloat(val.gst_per) || 0;
//   const margin = parseFloat(salesMargin) || 0;
//   const isAfterJulyFirst2025 = moment(val.docdate).isSameOrAfter("2025-07-01");

//   const baseWithMargin = outletType === "OTHERS" && isAfterJulyFirst2025
//     ? amount + (amount * margin / 100)
//     : amount;
//   // const baseWithMargin = outletType === "OTHERS"
//   //   ? amount + (amount * margin / 100)
//   //   : amount;

//   const gstAmount = baseWithMargin * (gstPer / 100);
//   const totalAmount = baseWithMargin + gstAmount;
// console.log(gstAmount,"gstAmount13333");

//   return (
//     <TableRow key={idx} className={classes.tablrow1}>
//       <TableCell sx={{ borderLeft: `1px solid #ccc` }}>{moment(val.docdate).format('DD-MM-YYYY')}</TableCell>
//       <TableCell>{val.docno}</TableCell>
//       <TableCell>{val.hsn}</TableCell>
//       <TableCell>{gstPer.toFixed(0)}</TableCell>
//       <TableCell>{Math.round(val.qty)}</TableCell>
//       <TableCell>{baseWithMargin.toFixed(2)}</TableCell>
//       <TableCell>{(gstAmount / 2).toFixed(2)}</TableCell>
//       <TableCell>{(gstAmount / 2).toFixed(2)}</TableCell>
//       <TableCell>{gstAmount.toFixed(2)}</TableCell>
//       <TableCell sx={{ textAlign: "right", fontWeight: 600 }}>{totalAmount.toFixed(0)}</TableCell>
//     </TableRow>
//   );
// })}

//             </TableBody>
// {/* 
//             <TableFooter sx={{ position: "sticky", bottom: 0, backgroundColor: "white" }}>
//               <TableRow className={classes.tablrow1}>
//                 <TableCell colSpan={5} sx={{ textAlign: "right", fontWeight: "bold" }}>Total</TableCell>
//                 <TableCell>{totalWithoutTax.toFixed(2)}</TableCell>
//                 <TableCell>{totalCGST.toFixed(2)}</TableCell>
//                 <TableCell>{totalSGST.toFixed(2)}</TableCell>
//                 <TableCell>{totalTax.toFixed(2)}</TableCell>
//                 <TableCell sx={{ textAlign: "right", fontWeight: "bold" }}>{totalMRP.toFixed(2)}</TableCell>
//               </TableRow>
//             </TableFooter> */}
//               <TableFooter sx={{ position: "sticky", bottom: 0, backgroundColor: "white" }}>
//                   <TableRow className={classes.tablrow1}>
//                     <TableCell sx={{ borderLeft: `1px solid #ccc`,textAlign:"right",fontWeight:"bold",fontSize:16,color:"#000" }} colSpan={5}>Total</TableCell>
//                     <TableCell sx={{textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalWithoutTax.toFixed(2)}</TableCell>
//                     <TableCell sx={{textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalCGST.toFixed(2)}</TableCell>
//                     <TableCell sx={{textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalSGST.toFixed(2)}</TableCell>
//                     <TableCell sx={{textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalTax.toFixed(2)}</TableCell>
//                     <TableCell sx={{ borderRight: `1px solid #ccc` ,textAlign:"right",fontWeight:"bold",fontSize:14,color:"#000"}}>{totalMRP.toFixed(0)}</TableCell>
                 
                 
//                   </TableRow>
                  
//                 </TableFooter>
//           </Table>
//         </TableContainer>
//       </Grid>
//     </Fragment>
//   );
// };

// export default memo(SalesTransferReport);

import {
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Autocomplete,
  TextField,
  TableFooter
} from '@mui/material';
import React, { Fragment, memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useStyle } from '../style';
import axios from 'axios';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import _ from 'lodash';
import { Helmet } from 'react-helmet-async';
import dayjs from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from 'moment';
import * as XLSX from 'xlsx';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import { CSVLink } from 'react-csv';

const SalesTransferReport = () => {
  const dispatch = useDispatch();
  const classes = useStyle();

  const [data, setData] = useState([]);
  const outletName = localStorage.getItem('outlet_name');
  const outletId = localStorage.getItem('outlet_id');
  const fixedOutlet = { id: outletId, fullname: outletName };
  const [supplier, setSupplier] = useState([]);
  const [salesMargin, setSalesMargin] = useState("0.00");
  const [outletType, setOutletType] = useState("");
  const roleId = localStorage.getItem("role_id");
  const [cust, setCust] = useState([]);

  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().subtract(1, 'months').format(),
    toDate: moment().format()
  });

  const ALL_OPTION = { id: 'all', fullname: 'All Outlets' };

  const getOptionsWithAll = () => [ALL_OPTION, ...supplier];

  // Handle change with special logic for All Outlets
  const handleChange = (event, values) => {
    if (values.some(v => v.id === ALL_OPTION.id)) {
      if (!cust.some(c => c.id === ALL_OPTION.id)) {
        // Select all (but store only actual outlets)
        setCust(supplier);
        const firstOutlet = supplier.length > 0 ? supplier[0] : null;
        setOutletType(firstOutlet?.outlet_type_name || "");
        setSalesMargin(firstOutlet?.sales_margin || "0.00");
      } else {
        // Deselect all
        setCust([]);
        setOutletType("");
        setSalesMargin("0.00");
      }
    } else {
      setCust(values);
      const firstOutlet = values.length > 0 ? values[0] : null;
      setOutletType(firstOutlet?.outlet_type_name || "");
      setSalesMargin(firstOutlet?.sales_margin || "0.00");
    }
  };

  // Override value to exclude ALL_OPTION from display tags but keep all selected when all are selected
  const getValue = () => {
    if (cust.length === supplier.length && supplier.length > 0) {
      return [...cust]; // Do NOT include ALL_OPTION tag in selected values, so it won't be displayed
    }
    return cust;
  };

  const getSupplierData = () => {
    axios.get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data);
        const selectedOutlet = res.data.find(val => val.id == outletId);
        if (selectedOutlet) {
          setCust([selectedOutlet]);
          setOutletType(selectedOutlet.outlet_type_name || "");
          setSalesMargin(selectedOutlet.sales_margin || "0.00");
        }
      })
      .catch(err => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  };

  const getSalesTransferReport = () => {
    const selectedOutletIds = cust.length ? cust.map(c => c.id) : [fixedOutlet.id];

    const postData = {
      from_date: moment(dateLimit.fromDate).format('YYYY-MM-DD'),
      to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: selectedOutletIds
    };

    axios.post(`/v1/reports/sales/transfer`, postData)
      .then(res => {
        setData(res.data || []);
      })
      .catch(err => {
        setData([]);
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
      });
  };

  useEffect(() => {
    getSupplierData();
  }, []);

  useEffect(() => {
    getSalesTransferReport();
  }, [dateLimit, cust, salesMargin, outletType]);

  const sortedData = _.sortBy(data, [item => moment(item.docdate).toDate()]);

  const totals = sortedData.reduce((acc, val) => {
    const amount = parseFloat(val.amount) || 0;
    const gstPer = parseFloat(val.gst_per) || 0;
    const margin = parseFloat(salesMargin) || 0;
    const isAfterJulyFirst2025 = moment(val.docdate).isSameOrAfter("2025-07-01");

    const baseWithMargin = outletType === "OTHERS" && isAfterJulyFirst2025
      ? amount + (amount * margin / 100)
      : amount;

    const gstAmount = baseWithMargin * (gstPer / 100);
    acc.amount += baseWithMargin;
    acc.gst_amt += gstAmount;
    acc.total += baseWithMargin + gstAmount;
    acc.cgst += gstAmount / 2;
    acc.sgst += gstAmount / 2;

    return acc;
  }, { amount: 0, gst_amt: 0, total: 0, cgst: 0, sgst: 0 });

  const totalWithoutTax = totals.amount;
  const totalCGST = totals.cgst;
  const totalSGST = totals.sgst;
  const totalTax = totals.cgst + totals.sgst;
  const totalMRP = totals.total;

  const csvData = sortedData.map(item => {
    const amount = parseFloat(item.amount) || 0;
    const gstPer = parseFloat(item.gst_per) || 0;
    const margin = parseFloat(salesMargin) || 0;
    const isAfterJulyFirst2025 = moment(item.docdate).isSameOrAfter("2025-07-01");

    const baseWithMargin = outletType === "OTHERS" && isAfterJulyFirst2025
      ? amount + (amount * margin / 100)
      : amount;

    const gstAmount = baseWithMargin * (gstPer / 100);
    const totalAmount = baseWithMargin + gstAmount;

    return {
      Date: moment(item.docdate).format('DD-MM-YYYY'),
      'Bill No': item.docno,
      'HSN': item.hsn,
      'Tax PER %': gstPer.toFixed(0),
      'Qty': Math.round(item.qty),
      'Base Value': baseWithMargin.toFixed(2),
      'CGST': (gstAmount / 2).toFixed(2),
      'SGST': (gstAmount / 2).toFixed(2),
      'Total Tax': gstAmount.toFixed(2),
      'Amount': totalAmount.toFixed(0),
    };
  });

  const csvDataWithTotal = [
    ...csvData,
    {},
    {
      Date: 'Total',
      'Bill No': '',
      'HSN': '',
      'Tax PER %': '',
      'Qty': '',
      'Base Value': totalWithoutTax.toFixed(2),
      'CGST': totalCGST.toFixed(2),
      'SGST': totalSGST.toFixed(2),
      'Total Tax': totalTax.toFixed(2),
      'Amount': totalMRP.toFixed(0),
    }
  ];

  return (
    <Fragment>
      <Helmet><title>Sales Transfer Report</title></Helmet>
      <Typography variant='h6'>Sales Transfer Report</Typography>

      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete
            multiple
            size="small"
            options={getOptionsWithAll()}
            value={getValue()}
            disableCloseOnSelect
            onChange={handleChange}
            getOptionLabel={(option) => option.fullname}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            disabled={roleId != 1 && roleId != 2}
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          />
        </Grid>

        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => setDateLimit(prev => ({ ...prev, fromDate: dayjs(e).format() }))}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{ textField: { size: "small", label: 'From', style: { width: '100%' } } }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => setDateLimit(prev => ({ ...prev, toDate: dayjs(e).format() }))}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{ textField: { size: "small", label: 'To', style: { width: '100%' } } }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>

      <Grid className='text-end my-2'>
        <CSVLink data={csvDataWithTotal} filename={"Sales_Transfer_Report.csv"} className="btn btn-outline-primary">
          <Button variant="outlined">Export to CSV <SimCardDownloadOutlinedIcon /></Button>
        </CSVLink>
      
      </Grid>

      <Grid className='flex'>
        <TableContainer className={classes.tblRoot} sx={{ height: "500px !important", overflow: "auto" }}>
          <Table>
            <TableHead className={classes.tblHeader} sx={{ position: "sticky", top: 0 }}>
              <TableRow className={classes.tablrow}>
                <TableCell colSpan={10} align='center' sx={{ borderLeft: `1px solid #ccc` }}>Sales Transfer Report</TableCell>
              </TableRow>
              <TableRow className={classes.tablrow}>
                <TableCell sx={{ borderLeft: `1px solid #ccc` }}>Date</TableCell>
                <TableCell>Bill No</TableCell>
                <TableCell>HSN</TableCell>
                <TableCell>Tax PER %</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell>Base Value</TableCell>
                <TableCell>CGST</TableCell>
                <TableCell>SGST</TableCell>
                <TableCell>Total Tax</TableCell>
                <TableCell>Amount</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {sortedData.map((val, idx) => {
                const amount = parseFloat(val.amount) || 0;
                const gstPer = parseFloat(val.gst_per) || 0;
                const margin = parseFloat(salesMargin) || 0;
                const isAfterJulyFirst2025 = moment(val.docdate).isSameOrAfter("2025-07-01");

                const baseWithMargin = outletType === "OTHERS" && isAfterJulyFirst2025
                  ? amount + (amount * margin / 100)
                  : amount;

                const gstAmount = baseWithMargin * (gstPer / 100);
                const totalAmount = baseWithMargin + gstAmount;

                return (
                  <TableRow key={idx} className={classes.tablrow1}>
                    <TableCell sx={{ borderLeft: `1px solid #ccc` }}>{moment(val.docdate).format('DD-MM-YYYY')}</TableCell>
                    <TableCell>{val.docno}</TableCell>
                    <TableCell>{val.hsn}</TableCell>
                    <TableCell>{gstPer.toFixed(0)}</TableCell>
                    <TableCell>{Math.round(val.qty)}</TableCell>
                    <TableCell>{baseWithMargin.toFixed(2)}</TableCell>
                    <TableCell>{(gstAmount / 2).toFixed(2)}</TableCell>
                    <TableCell>{(gstAmount / 2).toFixed(2)}</TableCell>
                    <TableCell>{gstAmount.toFixed(2)}</TableCell>
                    <TableCell sx={{ textAlign: "right", fontWeight: 600 }}>{totalAmount.toFixed(0)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>

            <TableFooter sx={{ position: "sticky", bottom: 0, backgroundColor: "white" }}>
              <TableRow className={classes.tablrow1}>
                <TableCell sx={{ borderLeft: `1px solid #ccc`, textAlign: "right", fontWeight: "bold", fontSize: 16, color: "#000" }} colSpan={5}>Total</TableCell>
                <TableCell sx={{ textAlign: "right", fontWeight: "bold", fontSize: 14, color: "#000" }}>{totalWithoutTax.toFixed(2)}</TableCell>
                <TableCell sx={{ textAlign: "right", fontWeight: "bold", fontSize: 14, color: "#000" }}>{totalCGST.toFixed(2)}</TableCell>
                <TableCell sx={{ textAlign: "right", fontWeight: "bold", fontSize: 14, color: "#000" }}>{totalSGST.toFixed(2)}</TableCell>
                <TableCell sx={{ textAlign: "right", fontWeight: "bold", fontSize: 14, color: "#000" }}>{totalTax.toFixed(2)}</TableCell>
                <TableCell sx={{ borderRight: `1px solid #ccc`, textAlign: "right", fontWeight: "bold", fontSize: 14, color: "#000" }}>{totalMRP.toFixed(0)}</TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>
    </Fragment>
  );
};

export default memo(SalesTransferReport);